import React from 'react';
import { Text } from '../../../../../../../../CommonComponents/OPL/Text/Text';
import { Box } from '../../../../../../../../CommonComponents/OPL/Box/Box';
import { ColumnChart } from '../../../../../../../../CommonComponents/OPL/charts/ColumnChart/ColumnChart';
import { Card } from '../../../../../../../../CommonComponents/OPL/Card/Card';
import { RothConversionChartDataDTO } from '../../RothConversion.types';
import { useRothConversionChart } from './useRothConversionChart';
import { TaxBracketSelector } from './components/TaxBracketSelector/TaxBracketSelector';
import { useChartReflow } from '../../../../../../hooks/useChartReflow';
import { useIsPdf } from '../../../../../../../hooks/useIsPdf';

interface Props {
  data: RothConversionChartDataDTO;
}

export const RothConversionChart: React.FC<Props> = ({ data }) => {
  const isPrint = useIsPdf();
  const {
    data: { series, categories, customSettings, brackets },
    actions: { setBrackets },
  } = useRothConversionChart({ data });

  const { chartRef } = useChartReflow();

  return (
    <Card display="flex" flexDirection="column" p="16">
      <Box display="flex" justifyContent="space-between">
        <Text variant="cardTitle" mb="24">
          Roth Conversion
        </Text>

        {!isPrint && (
          <Box>
            <TaxBracketSelector triggerText="Tax Bracket" data={brackets} onChange={setBrackets} />
          </Box>
        )}
      </Box>

      <Box height={330}>
        <ColumnChart
          series={series}
          categories={categories}
          customSettings={customSettings}
          yAxisType="currency"
          ref={chartRef}
        />
      </Box>
    </Card>
  );
};
